import { createSelector } from '@reduxjs/toolkit'
import { ADMIN_EMAIL } from '../../config/getEnvVars'
import { AppRootState, IAppState } from './reducer'

const rootState = (state: AppRootState | IAppState) =>
  'app' in state ? state.app : state

const normalizeEmail = (email?: string | null) =>
  email?.trim().toLowerCase() ?? ''

export const isAdminEmail = (
  email: string | null | undefined,
  adminEmail: string
) =>
  normalizeEmail(email) !== '' &&
  normalizeEmail(email) === normalizeEmail(adminEmail)

export const getIsLoading = createSelector(
  rootState,
  (state) => state.isLoading
)

export const getUserInfo = createSelector(rootState, (state) => state.userInfo)

export const getIsAuthenticated = createSelector(
  rootState,
  (state) => state.userInfo !== null
)

/** Returns a selector that checks if the current user email matches adminEmail. Pass admin email for testability. */
export const getIsAdmin = (adminEmail: string) =>
  createSelector(rootState, (state) =>
    isAdminEmail(state.userInfo?.email, adminEmail)
  )

export const getCustomerProfileId = createSelector(
  rootState,
  (state) => state.customerProfileId
)

export const getPortalCustomerProfileId = createSelector(rootState, (state) =>
  isAdminEmail(state.userInfo?.email, ADMIN_EMAIL)
    ? undefined
    : state.customerProfileId
)

export const getSubscriptionIds = createSelector(
  rootState,
  (state) => state.subscriptionIds
)

export const getPortalSubscriptionIds = createSelector(rootState, (state) =>
  isAdminEmail(state.userInfo?.email, ADMIN_EMAIL)
    ? undefined
    : state.subscriptionIds
)

export const getAlert = createSelector(rootState, (state) => state.alert)
